import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const WrapperWithMap = createComponent('div', {
  className: cx(
    'relative grid grid-rows-2 sm:grid-rows-1',
    'max-w-[1056px] sm:max-h-[476px] md:max-h-[456px]',
    'mx-auto px-2xl py-4xl sm:rounded-xl sm:px-4xl sm:py-8xl lg:px-6xl lg:py-8xl',
    'overflow-hidden'
  )
});

export const MobileSpaceTaker = createComponent('div', {
  className: 'sm:hidden'
});

export const ContactWrapper = createComponent('div', {
  className:
    'grid grid-cols-[auto_1fr] grid-rows-[auto_auto] items-start gap-x-8 gap-y-4'
});
